import React from 'react';
import {
  Modal,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import { EVENT_FILTER_LABELS } from '@/types/admin/events';
import { FilterModalProps } from './types';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { SVG_COMPONENTS } from '@/assets/admin';

export const FilterModal: React.FC<FilterModalProps> = ({
  visible,
  filters,
  onToggleFilter,
  onClose,
}) => {
  const { redesign, semantic } = useAdminColors();

  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
    >
      <SafeAreaView style={[styles.container, { backgroundColor: redesign.bg.base }]}>
        <View style={[styles.header, { borderBottomColor: redesign.card.border }]}>
          <Text style={[styles.title, { color: redesign.text.primary }]}>
            Filter Attendees
          </Text>
          <TouchableOpacity
            style={[styles.closeButton, { backgroundColor: semantic.interactive.primary }]}
            onPress={onClose}
            accessibilityLabel="Close filter modal"
            accessibilityHint="Tap to close the filter options and return to attendee list"
            accessibilityRole="button"
          >
            <Text style={styles.closeText}>Done</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.content}>
          {EVENT_FILTER_LABELS.map((label) => (
            <TouchableOpacity
              key={label.key}
              style={[
                styles.filterOption,
                { borderBottomColor: redesign.card.border },
              ]}
              onPress={() => onToggleFilter(label.key)}
              accessibilityLabel={`${label.title} filter`}
              accessibilityHint={`${
                filters[label.key]
                  ? 'Currently enabled. Tap to disable'
                  : 'Currently disabled. Tap to enable'
              } this filter option`}
              accessibilityRole="checkbox"
              accessibilityState={{ checked: filters[label.key] }}
            >
              <View style={styles.filterOptionContent}>
                <Text style={[styles.filterOptionText, { color: redesign.text.primary }]}>
                  {label.title}
                </Text>
                <View
                  style={[
                    styles.filterCheckbox,
                    { borderColor: redesign.card.border },
                    filters[label.key] && {
                      backgroundColor: semantic.interactive.primary,
                      borderColor: semantic.interactive.primary,
                    },
                  ]}
                >
                  {filters[label.key] && (
                    <SVG_COMPONENTS.CHECK_CIRCLE
                      width={14}
                      height={14}
                      color="white"
                    />
                  )}
                </View>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </SafeAreaView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
  },
  closeButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  closeText: {
    fontSize: 14,
    fontWeight: '600',
    color: 'white',
  },
  content: {
    padding: 20,
  },
  filterOption: {
    paddingVertical: 16,
    borderBottomWidth: 1,
  },
  filterOptionContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterOptionText: {
    fontSize: 16,
  },
  filterCheckbox: {
    width: 24,
    height: 24,
    borderRadius: 4,
    borderWidth: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
